<template>
  <v-menu class="mr-2"
          offset-y
          :close-on-content-click="false"
          :nudge-width="150"
          v-model="menu"
          transition="slide-y-transition">

    <v-avatar class="primary"
              size=30
              slot="activator">
      <v-icon dark>account_circle</v-icon>
    </v-avatar>

    <v-card>
      <v-list three-line>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>{{ user.manager.name }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ user.manager.username }}</v-list-tile-sub-title>
            <v-list-tile-sub-title>{{ user.manager.phone }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="error"
               flat
               block
               @click="userOptionsLogout">
          <v-icon class="mr-1">fa fa-power-off</v-icon>
          {{$t('private_menu_logout')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import store from '@/store';
import authService from '@/services/authService';

export default {
  name: 'user-details-dropdown',
  components: {},
  data() {
    return {
      user: store.state.user,
      menu: false
    };
  },
  methods: {
    userOptionsLogout(command) {
      authService.logout();
    }
  }
};
</script>

<style scoped>
.capitalize {
  text-transform: capitalize;
}
</style>




// WEBPACK FOOTER //
// src/components/commons/UserDetailsDropdown.vue